export interface IAppPlatformEntityBasedChatConfig {

	// Entity Details properties
	TopicId: string,
	TopicName: string,
	TopicEntityName: string,
	TagsForConnection: Array<string>,
	PersonId: string,

	// Participants info
	Recipients: Array<string>,  // Participants personids
	AllowedUserId: string,      // Other Participant's userid
	Email: string,              // Other Participant's email

	MailThreadLastMessage?: {
		MessageBody: string,
		SentOn: string
	},

	AlreadyChatPresents?: boolean,
	CallBack?(): any,
	defaultInputTextKey?: any,
	Name?: string;
	AllowUserIdForUpdate?: boolean

}

export interface IEntityBasedChatInsertPayload {

	ItemId: string,
	Language: string,
	Tags: Array<string>,

	TopicName: string,
	TopicEntityName: string,
	TopicId: string,
	Recipients: Array<string>,
	MailThreadId: string,

	IsMailThreadArchived?: boolean,
	MailThreadArchiveDetails?: {
		ArchivedBy: string,
		ArchivedOn: string
	},
	MailThreadLastMessage?: {
		MessageBody: string,
		SentOn: string
	}

}

export interface IAppPlatformEntitybasedChatCreationEventEmitPayload {
	TopicEntityName: string,
	PersonId: string, // Sender personId
	TopicId: string,
	Email: string, // Receiver Email Id
	ThreadId: string,
	TopicName: string,
	SourceFrom: string,
	defaultInputTextKey: string,
	Name: string,
	Recipients?:Array<string>
}
